module.exports = __webpack_public_path__ + "media/images/help/wf-join-site-95b9fbc418505302bc2828bcb58243df.png";